import { IRootState } from '../../../../store'
import { IPnMedicationState } from '../store/pnMedication.types'

export const getPnMedicationSelector = (state: IRootState): IPnMedicationState =>
  state.medicationAdministeredStateListPNNVs
